import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Icon } from '@popmenu/common-ui';
import { Eye } from '@popmenu/web-icons';
import { useIntl } from 'react-intl';

import { notBlankValidator, passwordValidator } from '../../utils/forms';
import { withSnackbar } from '../../utils/withSnackbar';
import { currentUserShape, withCurrentUser } from '../CurrentSessionProvider';
import updateUserMutation from '../../libs/gql/mutations/users/updateUserMutation.gql';

import BasicForm, { SubmitGroup, TextFieldGroup } from '../../admin/shared/forms/BasicForm';

const UserPasswordForm = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const intl = useIntl();
  return (
    <BasicForm
      labelPosition="top"
      mutate={{
        mutation: updateUserMutation,
        onCompleted: () => {
          props.showSnackbar(intl.formatMessage({ defaultMessage: 'Your password has been updated!' }));
        },
        toVariables: variables => ({
          userId: props.currentUser.id,
          userInput: {
            ...variables,
          },
        }),
      }}
    >
      <TextFieldGroup
        field="currentPassword"
        title={intl.formatMessage({ defaultMessage: 'Current Password' })}
        type="password"
        validate={notBlankValidator}
        variant="standard"
      />
      <TextFieldGroup
        field="password"
        title={intl.formatMessage({ defaultMessage: 'Password' })}
        type={showPassword ? 'text' : 'password'}
        validate={passwordValidator}
        helperText={intl.formatMessage({ defaultMessage: "Passwords must be 8+ characters, with both upper and lower cases, a number, and special character. May not include 'Popmenu'" })}
        variant="standard"
        InputProps={{
          endAdornment:
          (
            <React.Fragment>
              <Button
                data-cy={'preview_password'}
                data-tour-id="settings-my-profile-preview-password-button"
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
                size="xs"
                variant="text"
              >
                <Box color={!showPassword && 'gray.dark'} display="flex">
                  <Icon icon={Eye} />
                </Box>
              </Button>
            </React.Fragment>
          ),
        }}
      />
      <TextFieldGroup
        field="passwordConfirmation"
        title={intl.formatMessage({ defaultMessage: 'Password Confirmation' })}
        type="password"
        validate={passwordValidator}
        variant="standard"
      />
      <SubmitGroup
        color="primary"
        justifyContent="center"
        title={intl.formatMessage({ defaultMessage: 'Update Password' })}
        data-tour-id="settings-my-profile-update-password-button"
      />
    </BasicForm>
  );
};

UserPasswordForm.propTypes = {
  currentUser: currentUserShape.isRequired,
  showSnackbar: PropTypes.func.isRequired,
};

export default withCurrentUser(withSnackbar(UserPasswordForm));
